const dashboardIrregularNodesTypes = {
  init: 'VIEW_DASHBOARD_IRREGULAR_NODES',
  success: 'VIEW_DASHBOARD_IRREGULAR_NODES_SUCCESS',
  error: 'VIEW_DASHBOARD_IRREGULAR_NODES_ERROR',
};

const dashboardCaidasTypes = {
  init: 'VIEW_DASHBOARD_CAIDAS_NODES',
  success: 'VIEW_DASHBOARD_CAIDAS_NODES_SUCCESS',
  error: 'VIEW_DASHBOARD_CAIDAS_NODES_ERROR',
};

const dashboardResponseTimeTypes = {
  init: 'VIEW_DASHBOARD_RESPONSETIME_NODES',
  success: 'VIEW_DASHBOARD_RESPONSETIME_NODES_SUCCESS',
  error: 'VIEW_DASHBOARD_RESPONSETIME_NODES_ERROR',
};
const dashboardGeneralTableTypes = {
  init: 'VIEW_DASHBOARD_GENERAL_TABLE',
  success: 'VIEW_DASHBOARD_GENERAL_TABLE_SUCCESS',
  error: 'VIEW_DASHBOARD_GENERAL_TABLE_ERROR',
};

const dashboardTopInterfacesTypes = {
  init: 'VIEW_DASHBOARD_TOP_INTERFACES',
  success: 'VIEW_DASHBOARD_TOP_INTERFACES_SUCCESS',
  error: 'VIEW_DASHBOARD_TOP_INTERFACES_ERROR',
};

const dashboardMetricTypes = {
  init: 'VIEW_DASHBOARD_METRICS',
  success: 'VIEW_DASHBOARD_METRICS_SUCCESS',
  error: 'VIEW_DASHBOARD_METRICS_ERROR',
};

const dashboardChartsThresholdsTypes = {
  init: 'VIEW_DASHBOARD_METRICS_THRESHOLDS',
  success: 'VIEW_DASHBOARD_METRICS_THRESHOLDS_SUCCESS',
  error: 'VIEW_DASHBOARD_METRICS_THRESHOLDS_ERROR',
};

const dashboardFirstSectionTypes = {
  init: 'VIEW_DASHBOARD_FIRSTSECTION',
  success: 'VIEW_DASHBOARD_FIRSTSECTION_SUCCESS',
  error: 'VIEW_DASHBOARD_FIRSTSECTION_ERROR',
};

const nodeDetailsInterfacesTypes = {
  init: 'VIEW_NODE_DETAILS_INTERFACES',
  success: 'VIEW_NODE_DETAILS_INTERFACES_SUCCESS',
  error: 'VIEW_NODE_DETAILS_INTERFACES_ERROR',
};

const nodeDetailsGeneralInfoTypes = {
  init: 'VIEW_NODE_DETAILS_GENERAL_INFO',
  success: 'VIEW_NODE_DETAILS_GENERAL_INFO_SUCCESS',
  error: 'VIEW_NODE_DETAILS_GENERAL_INFO_ERROR',
};

const nodeDetailsPercentAvailabilityTypes = {
  init: 'VIEW_NODE_DETAILS_PERCENT_AVAILABILITY',
  success: 'VIEW_NODE_DETAILS_PERCENT_AVAILABILITY_SUCCESS',
  error: 'VIEW_NODE_DETAILS_PERCENT_AVAILABILITY_ERROR',
};

const dashboardChartNodesTypes = {
  init: 'VIEW_DASHBOARD_CHART_NODES',
  success: 'VIEW_DASHBOARD_CHART_NODES_SUCCESS',
  error: 'VIEW_DASHBOARD_CHART_NODES_ERROR',
};

const dashboardInterfaceSelectionTypes = {
  init: 'SELECT_DASHBOARD_INTERFACE_INIT',
  success: 'SELECT_DASHBOARD_INTERFACE_SUCCESS',
  error: 'SELECT_DASHBOARD_INTERFACE_ERROR',
};

const nodeDetailsSetFiltersTypes = {
  init: 'SELECT_NODE_DETAILS_FILTERS_INIT',
  success: 'SELECT_NODE_DETAILS_FILTERS_SUCCESS',
  error: 'SELECT_NODE_DETAILS_FILTERS_ERROR',
};

const inmuebleDeviceNodesTypes = {
  init: 'VIEW_INMUEBLE_DEVICE_NODES_INIT',
  success: 'VIEW_INMUEBLE_DEVICE_NODES_SUCCESS',
  error: 'VIEW_INMUEBLE_DEVICE_NODES_ERROR',
};

const toggleDarkModeTypes = {
  init: 'SELECT_DARK_MODE_INIT',
  success: 'SELECT_DARK_MODE_SUCCESS',
};

const metricThresholdTypes = {
  init: 'SELECT_METRIC_THRESHOLD_INIT',
  success: 'SELECT_METRIC_THRESHOLD_SUCCESS',
  error: 'SELECT_METRIC_THRESHOLD_ERROR',
};

export default {
  dashboardIrregularNodesTypes,
  dashboardCaidasTypes,
  dashboardResponseTimeTypes,
  dashboardGeneralTableTypes,
  dashboardTopInterfacesTypes,
  dashboardMetricTypes,
  dashboardFirstSectionTypes,
  nodeDetailsInterfacesTypes,
  nodeDetailsGeneralInfoTypes,
  nodeDetailsPercentAvailabilityTypes,
  dashboardChartNodesTypes,
  dashboardInterfaceSelectionTypes,
  nodeDetailsSetFiltersTypes,
  inmuebleDeviceNodesTypes,
  toggleDarkModeTypes,
  metricThresholdTypes,
  dashboardChartsThresholdsTypes
};
